import React from 'react'
import * as S from './styled'

interface DrawerItemProps {
  className?: string
  active?: boolean
  collapsed?: boolean
  icon: any
  text: string
  onPress?: () => void
}

const DrawerItem = ({
  text,
  onPress,
  icon,
  className,
  active,
  collapsed,
}: DrawerItemProps) => {
  const isPhone = window.innerWidth <= 767

  return (
    <S.LeftTabMenuItem onClick={onPress} className={className} active={active}>
      <S.LeftTabMenuIcon>{icon}</S.LeftTabMenuIcon>
      {!isPhone && <S.LeftTabMenuItemText>{text}</S.LeftTabMenuItemText>}
      {active && !isPhone && <S.Indicator collapsed={collapsed} />}
    </S.LeftTabMenuItem>
  )
}

export default DrawerItem
